<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div
	id="chat-widget"
	data-testid="chat-widget"
	role="button"
	tabindex="0"
	class="chat-window"
	in:fly={{ y: 100, duration: 1000 }}
	class:mobile-chat-window={$chatSession.deviceType === 'mobile'}
>
	{#if $showModal}
		<ChatWidgetModal {showModal} {modalId} {chatInitialized} {initChat} {restartConversation} />
	{/if}
	<ChatHeader {showModal} {modalId} />
	{#if !chatInitialized}
		<div class="loader">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="80"
				height="80"
				viewBox="0 0 100 100"
				fill="none"
			>
				<circle cx="50" cy="50" r="45" stroke="rgb(95, 60, 134)" stroke-width="10" opacity="0.2" />
				<path
					d="M50,10 A40,40 0 0,1 90,50"
					stroke="rgb(95, 60, 134)"
					stroke-width="10"
					stroke-linecap="round"
				>
					<animateTransform
						attributeName="transform"
						type="rotate"
						from="0 50 50"
						to="360 50 50"
						dur="1.5s"
						repeatCount="indefinite"
					/>
				</path>
			</svg>
		</div>
	{:else}
		<ChatMessages {typing} {clickedSuggestions} {clearSuggestionsInMessages} {clickedOrders}/>
		<ChatInput {typing} {clearSuggestionsInMessages} />
	{/if}
	<ChatFooter />
</div>

<script lang="ts">
	import { fly } from 'svelte/transition';
	import { onDestroy, onMount } from 'svelte';
	import { type Writable } from 'svelte/store';
	import ChatHeader from '$lib/components/chat/ChatHeader.svelte';
	import ChatMessages from '$lib/components/chat/ChatMessages.svelte';
	import ChatInput from '$lib/components/chat/ChatInput.svelte';
	import ChatFooter from '$lib/components/chat/ChatFooter.svelte';
	import ChatWidgetModal from '$lib/components/chat/ChatWidgetModal.svelte';
	import {
		chatSession,
		connectedToAgent,
		virtualAgentDisconnectMessageSent
	} from '$lib/stores/chatSessionStore';
	import { connect, socketDisconnect } from '$lib/stores/websocketStore';
	import { getWebsocketUrl } from '../../utilities/getWebsocketUrl';

	export let modalId: Writable<string>;
	export let showModal: Writable<boolean>;
	export let typing: Writable<boolean>;
	export let chatInitialized: Writable<boolean>;
	export let initChat: () => Promise<void>;
	export let restartConversation: () => Promise<void>;
	let socket: WebSocket | null = null;

	export let clickedSuggestions: { [key: string]: boolean };
	export let clickedOrders: { [key: string]: string };
	export let clearSuggestionsInMessages = (messages: typeof $chatSession.messages) => {
		return messages.map((msg) => ({
			...msg,
			params: {
				...(msg.params || {}),
				suggestions: msg.params?.suggestions ? [] : msg.params?.suggestions
			}
		}));
	};
	const unsubscribe = connectedToAgent.subscribe((isConnected) => {
		window.parent.postMessage({ type: 'flora-get-access-token' }, '*');
		if (isConnected) {
			if (!socket) {
				if (!$virtualAgentDisconnectMessageSent) {
					chatSession.update((old) => {
						return {
							...old,
							messages: [
								...old.messages,
								{
									sender: 'bot',
									message: 'AI Assistant Disconnected',
									type: 'text',
									params: {}
								}
							]
						};
					});
					virtualAgentDisconnectMessageSent.set(true);
				}
				const gardenWebsocketUrl = getWebsocketUrl();
				socket = connect(
					`${gardenWebsocketUrl}/websocket?token=${$chatSession.token}&conversationId=${$chatSession.conversation_id}&messageInterface=conversational_ui`,
					$chatSession.conversation_id,
					$chatSession.brand
				) as WebSocket;
			}
		} else {
			if (socket) {
				socketDisconnect();
				socket = null;
			}
		}
	});

	onDestroy(() => {
		unsubscribe();
	});
</script>

<style>
	.loader {
		height: 400px;
		justify-content: center;
		align-items: center;
		display: flex;
		margin-top: 50px;
		margin-bottom: 50px;
	}
	.chat-window {
		display: flex;
		flex-direction: column;
		background-color: white;
		width: 98vw;
		height: 90vh;
		overflow: hidden;
		box-shadow: 0 2px 2px #0000001a;
		border-top-right-radius: 10px;
		border-top-left-radius: 10px;
		border-bottom-right-radius: 10px;
		border-bottom-left-radius: 10px;
	}
	.mobile-chat-window {
		width: 100vw;
		height: 100vh;
	}
</style>
